<div class="relative" [ngClass]="inlineComponent ? 'no-border-dialog-container' : 'dialog-container pb-[60px]'">
  @if(!inlineComponent){
  <div class="header-section mb-3">
    <div class="w-full flex justify-center flex-col items-center">
      <p class="font-bold text-2xl leading-9 text-[#010B18] m-0">Live Property Data</p>
      <p class="font-normal text-sm leading-5 text-[#515765] m-2">Powered by</p>
      <img class="h-9 mb-3" src="assets/images/zillow-big-logo.svg" />
    </div>
  </div>
  <div class="absolute top-[42px] right-[44px]">
    <button type="button" class="close add-close-button h-8 w-8" data-dismiss="modal" (click)="closedialog()">
      <span style="font-size: 32px; font-weight: 500; color: #b1acb0" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  } @if (isFetchingData) {
  <div style="border: 1px solid rgba(211, 220, 232, 0.7)" class="h-60 text-center rounded-xl p-3 document-container">
    <!-- <img  class="mt-8" src="assets/images/fetch-vehicle.svg" /> -->
    <vehicle-loader [header_title]="'Zillow'"></vehicle-loader>
    <p class="font-semibold text-base text-[#53565B]">One moment while we get data for this property</p>
  </div>
  } @if (!isFetchingData) {
  <form
    [formGroup]="propertyForm"
    [ngClass]="inlineComponent ? 'no-padding-border-cus' : 'padding-border-cus'"
    class="rounded-xl p-6 document-container"
  >
    <div style="display: flex; justify-content: space-between">
      <div class="flex items-center gap-2">
        <p class="font-semibold text-base text-[#53565B]">Property Details</p>
        @if (!is_error &&!is_active_connection) {
        <p style="padding: 6px 8px" class="font-bold text-xs text-[#DEA000] rounded bg-[#FFF2CD]">No active connection</p>
        } @if (!is_error&&is_active_connection) {
        <p style="padding: 6px 8px" class="font-bold text-xs text-[#1AA140] rounded bg-[#DAF4F2]">Active Connection</p>
        } @if (is_error) {
        <p style="padding: 6px 8px" class="font-bold text-xs text-[#EB5757] rounded bg-[#F9D5DB]">Connection Error</p>
        }
      </div>
      @if(!is_error&&is_active_connection){
      <span class="disconnect__action--button" (click)="disconnectEstablishedConnection()">
        <span class="material-icons material-icons-round menuitem-icon text-[#EB5757]">link_off</span> Disconnect
      </span>
      }
    </div>
    <div
      style="display: flex; justify-content: space-between; padding: 0px; margin-left: 16px; flex-wrap: wrap; margin-right: 16px"
      class="flex-container mobile-form-container margin-top-custom gap-4 w-full"
    >
      <div class="gap-4 dynamic-form-field-container w-full my-0">
        <mat-form-field
          appearance="fill"
          floatLabel="auto"
          [ngClass]="isview ? 'disable-form-desing-form-only' : is_error ? 'automtic-form-desing-form-only-red' : 'automtic-form-desing-form-only'"
          (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
          class="w-full"
        >
          <mat-label class="automtic-form-desing-lable"> Street Address 1 </mat-label>
          <input #streetAddressInput matInput formControlName="StreetAddress" type="text" />
        </mat-form-field>
        <!-- <mat-form-field
          appearance="fill"
          floatLabel="auto"
          [ngClass]="isview ? 'disable-form-desing-form-only' : is_error ? 'automtic-form-desing-form-only-red' : 'automtic-form-desing-form-only'"
          class="w-full"
        >
          <mat-label class="automtic-form-desing-lable"> Unit Number </mat-label>
          <input matInput formControlName="UnitNumber" type="text" />
        </mat-form-field> -->
      </div>
      <div class="dynamic-form-field-container gap-2 w-full justify-between">
        <mat-form-field
          appearance="fill"
          floatLabel="auto"
          class="30%"
          [ngClass]="isview ? 'disable-form-desing-form-only' : is_error ? 'automtic-form-desing-form-only-red' : 'automtic-form-desing-form-only'"
          (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
        >
          <mat-label class="automtic-form-desing-lable"> City </mat-label>
          <input matInput formControlName="city" type="text" />
        </mat-form-field>
        <mat-form-field
          floatLabel="auto"
          appearance="fill"
          class="30%"
          [ngClass]="isview ? 'disable-form-desing-form-only' : is_error ? 'automtic-form-desing-form-only-red' : 'automtic-form-desing-form-only'"
        >
          <mat-label class="automtic-form-desing-lable"> State </mat-label>
          <mat-select class="example-panel-select add-edit-property-value-select" matNativeControl disableOptionCentering formControlName="state">
            @for (item of stateList; track item) {
            <mat-option [value]="item?.value">
              {{ item?.label }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          floatLabel="auto"
          appearance="fill"
          class="30%"
          [ngClass]="isview ? 'disable-form-desing-form-only' : is_error ? 'automtic-form-desing-form-only-red' : 'automtic-form-desing-form-only'"
          (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
        >
          <mat-label class="automtic-form-desing-lable"> ZIP Code </mat-label>
          <input matInput formControlName="zipCode" type="text" />
        </mat-form-field>
      </div>
      @if (is_error) {
      <div class="dynamic-form-field-container">
        <div class="flex gap-2">
          <mat-icon class="text-[#EB5757] h-4 w-4 flex-center" style="font-size: 16px">error_outline</mat-icon>
          <div class="text-xs font-semibold text-[#EB5757]">
            There was an error getting data for this property, please review the data submitted for any errors.
          </div>
        </div>
      </div>
      }
      <div class="dynamic-form-field-container w-full">
        <div class="app__centered-item block w-full">
          <!-- @if(showCopyDataButton && false){
            <div class="app__common--copy--btn app__centered-item app__form--attribute--title mt-2 my-4" (click)="copyDataFromGeneralInfo()">
              <span> Copy data from General Information </span>
            </div>
          }  -->
          @if (isview) {
          <button (click)="isview = false" class="h-8 rounded text-sm font-semibold w-full border border-[#25508e] text-k-blue bg-white">
            Update Property Details
          </button>
          } @if (!isview) {
          <button class="h-8 rounded w-full" [ngClass]="isFetchedData ? false : buttonClass" (click)="connectToPropertyDetails()">
            {{ !isFetchedData ? 'Connect' : 'Update Property Details' }}
          </button>
          }
        </div>
      </div>
    </div>
  </form>
  }
  <!-- @if(!inlineComponent){
  <div class="action" [ngClass]="inlineComponent ? 'inline-action-container' : 'action-container'">
    <form class="mt-4">
      <mat-slide-toggle
        style="margin: 18px 18px 0px 18px"
        class="font-normal text-[#515765] text-sm api-property-value margin-zero mb-0 mt-0"
        (change)="onChange()"
        [checked]="markOwnerAsComplete"
      >
        Mark this attribute complete
      </mat-slide-toggle>
    </form>
  </div>
  } -->
</div>
